export default {
  DOING: 'DOING',
  DONE: 'DONE',
  NOT_DONE: 'NOT_DONE',
};
